import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService } from '../message.service';
import { Dialog } from '../../../models/dialog.model';

export interface SelectableOption {
  id: number;
  name: string;
  keyCode?: string;
  color?: string; // Color personalizado opcional (clase CSS)
  [key: string]: any; // Para permitir propiedades adicionales
}

@Component({
  selector: 'app-option-selector-dialog',
  templateUrl: './option-selector-dialog.component.html',
  styleUrls: ['./option-selector-dialog.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class OptionSelectorDialogComponent implements OnInit, OnDestroy {
  dialog: Dialog = new Dialog();
  isVisible = false;
  animationClass: 'opt--enter' | 'opt--exit' | '' = '';

  public options: SelectableOption[] = [];
  public selectedOptionId: number | null = null;
  public showCancelButton: boolean = true;
  public defaultColor: string = 'boton--primario'; // Color por defecto
  private sub?: Subscription;

  constructor(private dialogService: MessageService) {}

  ngOnInit(): void {
    this.sub = this.dialogService
      .startOptionSelectorDialog()
      .subscribe(
        (data: {
          dialog: Dialog;
          options: SelectableOption[];
          showCancelButton?: boolean;
          defaultColor?: string;
        }) => {
          this.dialog = data.dialog;
          this.options = data.options;
          this.showCancelButton = data.showCancelButton !== undefined ? data.showCancelButton : true;
          this.defaultColor = data.defaultColor || 'boton--primario';
          this.open();
        },
      );
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  open(): void {
    this.isVisible = true;
    this.animationClass = 'opt--enter';
  }

  close(optionId: number | null): void {
    this.selectedOptionId = optionId;
    this.dialogService.sendOptionSelectorResponse(optionId);
    this.animationClass = 'opt--exit';
    setTimeout(() => {
      this.isVisible = false;
      this.animationClass = '';
      this.dialog = new Dialog();
      this.options = [];
      this.selectedOptionId = null;
    }, 180);
  }

  onBackdropClick(): void {
    if (!this.showCancelButton) return;
    this.onCancel();
  }

  onOptionSelect(optionId: number): void {
    this.close(optionId);
  }

  onCancel(): void {
    if (!this.showCancelButton) return;
    this.close(null);
  }

  // Método para obtener la clase de color de una opción
  getOptionColorClass(option: SelectableOption): string {
    return option.color || this.defaultColor;
  }
}
